/* jshint esversion:6 */
import service from '@/utils/request';

/**
 * 获取总学时信息
 */
export function getCreditSum(year) {
    return service({
        url: '/credit/getCommonCredit',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
        params: {
            year
        }
    });
}

/**
 * 获取学时年份
 */
export function getYear() {
    return service({
        url: '/creditSum/getYear',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
    });
}

/**
 * 获取学习档案信息
 */
export function getCredit(pageNo, pageSize) {
    return service({
        url: '/credit/getCredit',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
        params: {
            pageNo,
            pageSize,
        }
    });
}

/**
 * 获取普通课程以及推荐课程学时档案
 */
export function getCommonCredit(pageNo, pageSize) {
    return service({
        url: '/credit/getCommonListCredit',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
        params: {
            pageNo,
            pageSize,
        }
    });
}

/**
 * 获取个人信息
 */
export function getStudent() {
    return service({
        url: '/user/getUserDetail',
        method: 'get',
        // data = Request Payload, params = Query String Parameters
    });
}



// WEBPACK FOOTER //
// ./src/api/personal.js


// WEBPACK FOOTER //
// ./src/api/personal.js